import { axios, path } from './config';
import { formatApiDateRange } from './utils';
import qs from 'qs';

export function startReportGeneration({ params, dateRange }) {
  let field = '';
  const queryFilter = [];
  if (params.timeframe) {
    field = 'time';
  }
  const { timeframe } = params;
  if (timeframe.value !== 'All') {
    if (timeframe.value === 'Custom') {
      const customTimeframe = formatApiDateRange({ dateRange });
      queryFilter.push({
        fieldName: field,
        type: 'Equals',
        value: customTimeframe,
      });
    } else {
      queryFilter.push({
        fieldName: field,
        type: 'Equals',
        value: timeframe.value,
      });
    }
  }

  return axios
    .get(params.report.url, {
      params: {
        channel: params.report.channel,
        date_range: formatApiDateRange({ dateRange }),
        filter: JSON.stringify(queryFilter),
      },
    })
    .then((response) => response);
}

export function users({ dateRange, pageNumber, itemsPerPage, sort, filter }) {
  // search is used instead of filter to get user data matching omniSearch field in database
  // omniSearch is created using USERNAME_FIRSTNAME_LASTNAME
  const userName =
    filter && filter.length
      ? filter.find((field) => field.fieldName === 'username')
      : { value: '' };
  const params = {
    date_range: formatApiDateRange({ dateRange }),
    page: pageNumber,
    items_per_page: itemsPerPage,
    sort,
    search: userName.value,
  };

  return axios.get(path.USERS_REPORT, { params });
}

export function campaigns({ dateRange, pageNumber, itemsPerPage, sort, filter }) {
  const { omniSearch } = filter;
  const params = {
    date_range: formatApiDateRange({ dateRange }),
    page: pageNumber,
    // eslint-disable-next-line no-magic-numbers
    items_per_page: itemsPerPage === null ? 10 : itemsPerPage,
    sort,
  };

  if (omniSearch) {
    params.search = omniSearch;
  }
  return axios.get(path.CAMPAIGNS_REPORT, { params });
}

export function metrics({ metricsType, dateRange, aggregationTimeframe, channel }) {
  const params = {
    date_range: formatApiDateRange({ dateRange }),
    channel,
    metrics_type: metricsType,
    aggregation_timeframe: aggregationTimeframe,
  };

  return axios.get(path.METRICS_REPORT, { params });
}

export function sequence({ sequenceId, dateRange }) {
  const params = {
    date_range: formatApiDateRange({ dateRange }),
    sequence_id: sequenceId,
  };

  return axios.get(path.SEQUENCE_REPORT, { params });
}

export function getSequenceCandidates({ sequenceId, dateRange, aggregationTimeframe }) {
  const params = {
    date_range: formatApiDateRange({ dateRange }),
    sequence_id: sequenceId,
    aggregation_timeframe: aggregationTimeframe,
  };

  return axios.get(path.SEQUENCE_CANDIDATE_REPORT, { params });
}

export function getReportsUniqueMessageSent({ dateRange, aggregationTimeframe }) {
  const params = {
    date_range: formatApiDateRange({ dateRange }),
    aggregation_timeframe: aggregationTimeframe,
  };

  const updatedParams = qs.stringify(params);

  return axios.get(`${path.METRICS_TEAMS}${updatedParams}`);
}
export function getUserData({ dateRange, aggregationTimeframe, userId }) {
  const params = {
    date_range: formatApiDateRange({ dateRange }),
    aggregation_timeframe: aggregationTimeframe,
    user_id: userId,
  };
  return axios.get(path.METRICS_REPORT_USERS, { params });
}

export function getScheduledMessagesSearch({ userId, itemsPerPage, page }) {
  const queryFilter = [];
  queryFilter.push({ fieldName: 'status', type: 'Equals', value: 'Pending' });
  const params = {
    user_id: userId,
    items_per_page: itemsPerPage,
    page,
    filter: JSON.stringify(queryFilter),
  };
  return axios.get(path.SCHEDULED_MESSAGES_SEARCH + qs.stringify({ ...params }));
}
